import React, { Component } from 'react'
import classnames from 'classnames'
import { FormButton } from '@myxplor/forms'
import { Heading } from '@myxplor/ui'
import { ContentToggleIcon } from '@myxplor/icons'
import { withToggle } from '../../../ui/show-hide'
import DefaultForm from '../../../ui/forms/default-form'
import { GovActionContentWrapper } from '../../../ui/gov-actions'
import CaseClaimForm, { validate, calculateSubmitValues } from './form'
import { calcPaymentOptions, calcServiceProvisionOptions } from './form/helpers'
import { CreateCaseClaimDone } from './create-claim-done'

const apiEndPoint = ({ issCase }) =>
  [process.env.REACT_APP_API_HOST, 'api', 'iss-cases', issCase.gov_id, 'iss-case-claims'].join('/')

class CreateClaim extends Component {
  constructor(props) {
    super(props)
    this.state = { completed: false }
  }

  handleSuccess() {
    this.setState({ completed: true })
  }

  renderInputs() {
    const { open, issCase, refresh_iss_case_claim, govRego } = this.props
    const paymentTypeOptions = calcPaymentOptions(issCase)
    const serviceProvOptions = calcServiceProvisionOptions(issCase)
    const { completed } = this.state

    if (completed) {
      return <CreateCaseClaimDone refresh={refresh_iss_case_claim} />
    }

    if (open) {
      return (
        <GovActionContentWrapper>
          <Heading small compact>
            Create a new ISS Case Claim
          </Heading>
          <DefaultForm
            url={apiEndPoint({ issCase, govRego })}
            formOptions={{
              validate,
              defaultValues: {
                service_provision: serviceProvOptions[0].value,
                payment_type: paymentTypeOptions[0].value,
                children: [],
                days: {},
                declaration_signed: false,
                week_start: govRego.start_date,
              },
            }}
            formComponent={formProps => (
              <CaseClaimForm
                {...formProps}
                issCase={issCase}
                govRego={govRego}
                serviceProvOptions={serviceProvOptions}
                paymentTypeOptions={paymentTypeOptions}
                weekStart={govRego.start_date}
              />
            )}
            calculateSubmitValues={calculateSubmitValues}
            handleSuccess={this.handleSuccess.bind(this)}
            label="Create ISS Case Claim"
            loadingTitle="Submitting ISS Case Claim"
          />
        </GovActionContentWrapper>
      )
    }

    return null
  }

  render() {
    const { open, toggle, refresh_iss_case_claim } = this.props
    const { completed } = this.state

    return (
      <div
        className={classnames({
          'govListActions--wrapper': true,
          'govListActions--wrapper__open': open,
        })}>
        <FormButton onClick={completed ? refresh_iss_case_claim : toggle}>
          <ContentToggleIcon left open={open} />
          {open ? 'Cancel' : 'New ISS Case Claim'}
        </FormButton>
        {this.renderInputs()}
      </div>
    )
  }
}

export default withToggle(CreateClaim)



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/create-claim.jsx